import React, { PropsWithChildren } from 'react'
import { styled } from '~/app/components'
import { Typography } from '@yanolja-rnd/ya-com-core'

/**
 * EmptyList component
 * author: soojin.oh
 */

// styled components
const Container = styled.div`
  width: 100%;
  padding: 13.2rem 0 0 0;
`
const NoProduct = styled.div`
  color: ${({ theme }) => theme.color.gray900};
  ${Typography('subtitle3.multiline').regular};
  text-align: center;
  width: 100%;
`
const Recommend = styled.div`
  color: ${({ theme }) => theme.color.gray600};
  ${Typography('body1').regular};
  text-align: center;
  width: 100%;
`

// EmptyList component
const EmptyList = function ({
  isEmpty,
  notFound,
  children,
}: PropsWithChildren<{ isEmpty: boolean; notFound?: boolean }>) {
  return (
    <>
      {isEmpty ? (
        <Container>
          <NoProduct>
            {notFound ? '예약 조회가 불가합니다.' : '이용 가능한 상품이 없습니다.'}
          </NoProduct>
          <Recommend>상품을 예약해보세요.</Recommend>
        </Container>
      ) : (
        children
      )}
    </>
  )
}

export default EmptyList
